(() => {
  'use strict';
  document.querySelectorAll('[data-haley-selection]').forEach((panel) => {
    const section = panel.closest('.shopify-section');
    let data;
    try { data = JSON.parse(panel.querySelector('[data-selection-data]').textContent); } catch { return; }
    let selected;
    let summary;
    let selectedUrl;
    const share = panel.querySelector('[data-selection-share]');
    const status = panel.querySelector('[data-selection-status]');
    const canonical = document.querySelector('link[rel="canonical"]')?.href || window.location.href;

    function sync(variantId) {
      const inputId = section?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      selected = data.variants.find((variant) => String(variant.id) === String(variantId || inputId || data.variantId));
      if (!selected) return;
      selectedUrl = new URL(data.url, new URL(canonical).origin);
      selectedUrl.searchParams.set('variant', selected.id);
      summary = `${data.title}\n${data.strings.selected_size}：${selected.title}\n${selected.priceLabel}`;
      if (data.currency === 'HKD' && selected.price >= 400000) {
        const estimate = new Intl.NumberFormat('en-HK', { style: 'currency', currency: 'HKD' }).format((selected.price - 150000) / 100);
        summary += `\n${data.strings.promo_estimate} ${estimate}\n${data.strings.promo_terms}`;
      }
      panel.querySelector('[data-selection-summary]').textContent = summary;
      // Customer-voice WhatsApp text: model, size, price, link, source, then a slot for the question.
      // Promo terms stay in the on-page summary only, not in the shopper's message.
      const message = [data.strings.wa_intro, data.title, `${data.strings.selected_size}：${selected.title}`, selected.priceLabel, selectedUrl.href, data.strings.source_product, data.strings.wa_ask].filter(Boolean).join('\n');
      const links = section?.querySelectorAll('a[data-cro-event="whatsapp_click"]') || [];
      links.forEach((link) => {
        const url = new URL(link.href);
        if (!['wa.me', 'api.whatsapp.com'].includes(url.hostname)) return;
        url.searchParams.set('text', message);
        link.href = url.href;
        link.dataset.croVariant = String(selected.id);
      });
      const wa = new URL(`https://wa.me/${String(data.whatsapp).replace(/\D/g, '')}`);
      wa.searchParams.set('text', message);
      panel.querySelector('[data-selection-whatsapp]').href = wa.href;
      panel.querySelector('[data-selection-copy]').value = selectedUrl.href;
      const booking = panel.querySelector('[data-selection-book]');
      const bookingUrl = new URL(booking.href);
      bookingUrl.searchParams.set('selection', `${data.title} · ${selected.title}`);
      booking.href = bookingUrl.href;
      share.hidden = false;
    }

    section?.addEventListener('haley:variant-change', (event) => sync(event.detail.id));
    sync();
    share.addEventListener('click', async () => {
      if (!selected) return;
      const payload = { title: data.title, text: `${summary}\n${data.strings.share_note}`, url: selectedUrl.href };
      try {
        if (navigator.share) {
          await navigator.share(payload);
        } else if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(`${payload.text}\n${payload.url}`);
          status.textContent = data.strings.copied;
        } else {
          panel.querySelector('[data-selection-copy-label]').hidden = false;
          panel.querySelector('[data-selection-copy]').select();
          return;
        }
        document.dispatchEvent(new CustomEvent('haley:track', { detail: { event: 'selection_share', placement: 'product_selection', product: data.handle, variant: String(selected.id) } }));
      } catch (error) {
        if (error.name === 'AbortError') return;
        panel.querySelector('[data-selection-copy-label]').hidden = false;
        panel.querySelector('[data-selection-copy]').select();
      }
    });
  });
})();
